<template>
  <router-view/>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const checkMobileLayout = () => {
  if (typeof window !== 'undefined') {
    const isMobile = window.innerWidth <= 768
    store.commit('setIsMobile', isMobile)
  }
}

onMounted(() => {
  checkMobileLayout()
  window.addEventListener('resize', checkMobileLayout)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobileLayout)
})
</script>